<template>
  <div class="mt-10">
    <md-card>
      <md-card-expand>
        <md-card-actions md-alignment="space-between">
          <md-card-expand-trigger>
            <md-button class="expand-button-size">
              <strong>
                Coach Revisions <span>({{ revisions.length }})</span>
              </strong>
            </md-button>
          </md-card-expand-trigger>
        </md-card-actions>

        <md-card-expand-content>
          <md-card-content class="comments">
            <div class="activity-log" v-if="revisions.length">
              <div 
                v-for="(revision, index) in revisions" 
                :key="revision._id"
                class="revision-block p-4 border rounded mb-4 bg-gray-50"
              >
                <h4 class="font-semibold mb-2">Revision {{ index + 1 }}</h4>
                <p><strong>Draft:</strong></p>
                <p class="mb-2">{{ revision.draft }}</p>

                <div v-if="revision.feedback">
                  <h5 class="font-semibold mt-2">Feedback</h5>

                  <div v-if="revision.feedback.strengths && revision.feedback.strengths.length">
                    <p><strong>Strengths:</strong></p>
                    <ul>
                      <li v-for="(item, sIndex) in revision.feedback.strengths" :key="sIndex"> {{ item }}</li>
                    </ul>
                  </div>

                  <div v-if="revision.feedback.improvements && revision.feedback.improvements.length">
                    <p><strong>Improvements:</strong></p>
                    <ul>
                      <li v-for="(item, iIndex) in revision.feedback.improvements" :key="iIndex"> {{ item }}</li>
                    </ul>
                  </div>
                </div>

                <div class="mt-2 text-sm text-gray-600">
                  <p><strong>Overall Score:</strong> {{ revision.feedback.overall_score }}</p>
                  <p><strong>Created:</strong> {{ revision.created_at | momentDate }}</p>
                </div>
              </div>
            </div>

            <div v-else class="text-gray-500 p-4">
              No revisions yet.
            </div>
          </md-card-content>
        </md-card-expand-content>
      </md-card-expand>
    </md-card>
  </div>
</template>

<script>
import API from "../services/API";

export default {
  name: "CoachLog",
  props: ["ask", "section"],
  data() {
    return {
      api: new API(),
      revisions: [],
      coachSession: null,
    };
  },
    watch: {
    'ask.coachingSessionId': {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.loadCoachRevisions();
        }
      },
    },
  },
mounted() {
  if (this.ask.coachingSessionId) this.loadCoachRevisions();
},
  methods: {
    async loadCoachRevisions() {
      try {
        if (!this.ask.coachingSessionId) {
          console.warn("No coachingSessionId found in ask");
          return;
        }

        const res = await this.api.get(`/coach/${this.ask.coachingSessionId}`);
        if (res && res.data) {
          this.coachSession = res.data;
          this.revisions = res.data.revisions || [];
        }
      } catch (err) {
        console.error("Error fetching coach revisions:", err);
      }
    },
  },
};
</script>

<style scoped>
.revision-block {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/CoachLog.vue